import { render, staticRenderFns } from "./ApproveWork.vue?vue&type=template&id=0c6407fa&scoped=true&lang=pug"
import script from "./ApproveWork.vue?vue&type=script&lang=js"
export * from "./ApproveWork.vue?vue&type=script&lang=js"
import style0 from "./ApproveWork.vue?vue&type=style&index=0&id=0c6407fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6407fa",
  null
  
)

export default component.exports